"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.allColonyNames = allColonyNames;
exports.getColony = getColony;
const colonies_json_1 = __importDefault(require("@/genfiles/colonies.json"));
const colonies = new Map();
colonies_json_1.default.forEach((colony) => {
    colonies.set(colony.name, colony);
});
function allColonyNames() {
    return colonies.keys();
}
function getColony(name) {
    const metadata = colonies.get(name);
    if (metadata === undefined) {
        throw new Error(`Unknown colony ${name}`);
    }
    return metadata;
}
